import React, { useState } from "react";
import Day1Card from "../../day1_card/Day1_Card";
import Day2Card from "../../day2_card/Day2_Card";
import Day3Card from "../../day3_card/Day3_Card";
import { Accordion } from "react-bootstrap";
import "./Summarised_View.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons";
import Inner_Summary_Card from "./inner_summary_card/Inner_Summary_Card";

const Summarised_View = ({ data }) => {
  const [activeTab, setActiveTab] = useState("Itinerary");
  const [openAccordion, setOpenAccordion] = useState(null);

  const toggleAccordion = (index) => {
    setOpenAccordion(openAccordion === index ? null : index);
  };

 
  const icons = {
    meal: "/assets/images/cruise/itenarary/day-meal.png",
    checkout: "/assets/images/cruise/itenarary/checkout.png",
    car: "/assets/images/cruise/itenarary/private-tranfer.png",
    bed: "/assets/images/cruise/itenarary/bed-img.png",
    map: "/assets/images/cruise/itenarary/activity.png",
    flight: "/assets/images/cruise/itenarary/flight1.png",
  };


  return (
    <div className="Itinerary_Tab">
      <>
        <div className="city_header">
          {data?.title} - <span>{data?.duration}</span>
        </div>

        <Accordion defaultActiveKey="0" className="custom_accordion">
          {data?.itineraries?.map((d, index) => (
            <Accordion.Item eventKey={index.toString()} >
              <Accordion.Header>
                {d?.title}

                <div className="icon_holder">
                  <FontAwesomeIcon
                    icon={faAngleDown}
                    className="inner_icon down_icon"
                  />
                  <FontAwesomeIcon
                    icon={faAngleUp}
                    className="inner_icon up_icon"
                  />
                </div>
              </Accordion.Header>

              <Accordion.Body>
                <Inner_Summary_Card
                  item={d}
                  // item={itineraryData[0]}
                  icons={icons}
                  // index={0}
                  // mainImage={mainImages[0]}
                  // changeMainImage={changeMainImage}
                />
              </Accordion.Body>
            </Accordion.Item>
          ))}

          {/* <Accordion.Item eventKey="1">
            <Accordion.Header>
              {itineraryData[1].title}

              <div className="icon_holder">
                <FontAwesomeIcon
                  icon={faAngleDown}
                  className="inner_icon down_icon"
                />
                <FontAwesomeIcon
                  icon={faAngleUp}
                  className="inner_icon up_icon"
                />
              </div>
            </Accordion.Header>

            <Accordion.Body>
              <Day2Card item={itineraryData[1]} icons={icons} />
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="2">
            <Accordion.Header>
              {itineraryData[2].title}

              <div className="icon_holder">
                <FontAwesomeIcon
                  icon={faAngleDown}
                  className="inner_icon down_icon"
                />
                <FontAwesomeIcon
                  icon={faAngleUp}
                  className="inner_icon up_icon"
                />
              </div>
            </Accordion.Header>

            <Accordion.Body>
              <Day3Card item={itineraryData[2]} icons={icons} />
            </Accordion.Body>
          </Accordion.Item> */}
        </Accordion>
      </>
    </div>
  );
};

export default Summarised_View;
